import "./src/sentry"; // ── Sentry MUST be first import ──────────────────
import React from "react";
import ReactDOM from "react-dom/client";
// Fix: Add file extension to import path.
import App from "./App";
import "./index.css";
import "./cherrycrm.css";
import "./src/design-system.css";
import { supabase } from "./src/lib/supabaseClient";

// --- Global Fetch Interceptor ---
// Ensure legacy components using native fetch() still send the auth token
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const [resource, config] = args;
  const url =
    typeof resource === "string"
      ? resource
      : resource instanceof Request
        ? resource.url
        : "";

  if (url.startsWith("/api/")) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (session?.access_token) {
        const newConfig = config || {};
        const headers = new Headers(
          newConfig.headers ||
            (resource instanceof Request ? resource.headers : undefined),
        );

        if (!headers.has("Authorization")) {
          headers.set("Authorization", `Bearer ${session.access_token}`);
          newConfig.headers = headers;
        }

        if (typeof resource === "string") {
          return originalFetch(resource, newConfig);
        } else if (resource instanceof Request) {
          return originalFetch(new Request(resource, newConfig));
        }
      }
    } catch (e) {
      console.warn("Fetch interceptor error:", e);
    }
  }
  return originalFetch(...args);
};
// --------------------------------

const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error("FATAL: Could not find root element to mount to");
  throw new Error("Could not find root element to mount to");
}

// Global Interceptors to suppress harmless Supabase AbortErrors during quick unmounts
window.addEventListener("unhandledrejection", (event) => {
  if (
    event.reason &&
    (event.reason.name === "AbortError" ||
      (event.reason.message && event.reason.message.includes("AbortError")))
  ) {
    event.preventDefault(); // Stop the noisy "Uncaught (in promise) AbortError" from hitting the console
  }
});

const originalConsoleError = console.error;
console.error = (...args) => {
  const isAbortError = args.some(
    (arg) =>
      (arg && arg.name === "AbortError") ||
      (typeof arg === "string" && arg.includes("AbortError")) ||
      (arg &&
        typeof arg.message === "string" &&
        arg.message.includes("AbortError")),
  );
  if (isAbortError) return; // Suppress caught manual console.errors containing AbortError
  originalConsoleError(...args);
};

const root = ReactDOM.createRoot(rootElement);
root.render(
  (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) as any,
);
